import PropTypes from "prop-types";
import withRouter from "app/utils/hocs/withRouter";
import { messagePropType } from "app/utils/propTypes";
import { useSelector, shallowEqual } from "react-redux";
import ReasonToBookBlock from "app/pages/.shared/ReasonsToBook/ReasonToBookBlock/ReasonToBookBlock";
import {
	getComputedReasonToBookList,
	getPartnerCode,
	shouldShowReasonToBook,
} from "app/reducers/partnerSelector";
import { useLocation } from "react-router-dom";

const mapStateToProps = (state, ownProps) => {
	const { location } = ownProps;
	const { signupTitle, defaultTitle, items = [] } = getComputedReasonToBookList(state);
	const isSignupPage =
		location.pathname.includes("/sign-up") || location.pathname.includes("/home");

	const partnerCode = getPartnerCode(state);
	const isSVUM = partnerCode?.includes("SVUM");

	return {
		title: isSignupPage ? signupTitle || defaultTitle : defaultTitle,
		reasonToBookList: items,
		shouldShowReasonToBook: !isSVUM && shouldShowReasonToBook(state),
	};
};

const ReasonToBookBlockContainer = ownProps => {
	const stateProps = useSelector(state => mapStateToProps(state, ownProps), shallowEqual);
	const props = { ...ownProps, ...stateProps };
	const { pathname } = useLocation();

	// use key={pathname} to force ReasonToBookBlock to rerender to reset carousel index to 0
	return props.shouldShowReasonToBook ? <ReasonToBookBlock {...props} key={pathname} /> : false;
};

ReasonToBookBlockContainer.propTypes = {
	title: messagePropType,
	reasonToBookList: PropTypes.array,
	shouldShowReasonToBook: PropTypes.bool,
};

export default withRouter(ReasonToBookBlockContainer);
